import { Spacer, Text } from '@vapor/ui';
import { Content } from '../components/boxes/content';
import { MarketingLayout } from '../layout/marketing';

export default function Privacy() {
  return (
    <MarketingLayout>
      <Content style={{ maxWidth: 800 }}>
        <Text as="h1" size={40} weight={600}>
          Refund and Payment Policy
        </Text>

        <Spacer height={25} />
        <Text as="h2" size={20} weight={600}>
          Merchant of Record
        </Text>
        <Spacer height={10} />

        <p>
          Our order and payment process is conducted by our online reseller Paddle. Paddle is
          the Merchant of Record for all our orders. Paddle provides all customer service
          inquiries and handles returns. Please visit{' '}
          <a href="https://paddle.net">paddle.net</a> if you encounter any problems with your
          payment.
        </p>

        <Spacer height={25} />
        <Text as="h2" size={20} weight={600}>
          Trial
        </Text>
        <Spacer height={10} />

        <p>
          All paid plans include a 7 day free trial. You will get billed if you don't cancel
          your subscription before the end of the trial.
        </p>

        <Spacer height={25} />
        <Text as="h2" size={20} weight={600}>
          Refunds
        </Text>
        <Spacer height={10} />

        <p>
          Refunds are determined at the sole discretion of the our merchant of record{' '}
          <a href="https://paddle.net">Paddle</a> and on a case-by-case basis. Please visit{' '}
          <a href="https://paddle.net">paddle.net</a> if you think you have a valid reason for
          a refund. You can learn more about Paddle's refund and dispute policy in{' '}
          <a href="https://www.paddle.com/legal/checkout-buyer-terms">
            Paddle's Checkout Buyer Terms and Conditions
          </a>
          .
        </p>

        <Spacer height={25} />
        <Text as="h2" size={20} weight={600}>
          Disputes, Unrecognized Charges and Problems with your Order
        </Text>
        <Spacer height={10} />

        <p>
          Orders are handled by our merchant of record <a href="https://paddle.net">Paddle</a>.
          Please contact Paddle at <a href="paddle.net">paddle.net</a> if you have any
          questions about your order.
        </p>
      </Content>
    </MarketingLayout>
  );
}
